
// // Localhost
// export const CORE_API_ENDPOINT = "http://localhost:2803"
// export const CORE_API_ENDPOINT = "https://solardashboarddev.cigblusolutions.com/api"
export const CORE_API_ENDPOINT = "https://airportdev.cigblusolutions.com/api"
export const REDIRECT_O365_URI = "http://localhost:8080/login"
export const AX_URL = 'http://localhost:8080'
export const API_MAP_KEY = 'AIzaSyAr0_xNXVux88WH3bK9cyke7J23SlXMRZ0';


// WEBPACK FOOTER //
// ./src/lib/api.js